import { SquareIcon } from '@otter-ai/den-icons';
import type { ReactNode } from 'react';

type TemplateGalleryBuilderBlockProps = {
  icon: ReactNode;
  title: string;
  content: string | string[] | null;
};

export function TemplateGalleryBuilderBlock(
  props: TemplateGalleryBuilderBlockProps,
) {
  const { icon, title, content } = props;
  // Render an empty block if content is null
  if (content === null) {
    return (
      <div className="border-dotted border-2 border-subtle h-[140px] flex items-center justify-center rounded-md p-1 mt-2">
        <span>{''}</span>
      </div>
    );
  }

  // Function to render the block content based on its type
  const renderBlockContent = () => {
    if (Array.isArray(content)) {
      if (title === 'Action Items') {
        return content.map((item, index) => (
          <div
            className="flex gap-1 text-sm pl-6 w-full"
            key={`${item}-${index}`}
          >
            <SquareIcon size={20} className="shrink-0" />
            <span className="flex-1">{item}</span>
          </div>
        ));
      }

      return (
        <ul className="list-disc list-outside pl-10 text-sm space-y-1">
          {content.map((item, index) => (
            <li key={`${item}-${index}`}>{item}</li>
          ))}
        </ul>
      );
    }

    return <div className="text-sm pl-7">{content}</div>;
  };

  return (
    <div className="mt-4">
      <div className="flex gap-1.5 items-center">
        {icon}
        <span className="text-md font-semibold">{title}</span>
      </div>
      <div className="py-1">{renderBlockContent()}</div>
    </div>
  );
}
